import React, { useState, useEffect, useMemo, useCallback } from "react"

import { useFunctions } from "../../../hooks/useFunctions"
import { useShopify } from "../../../hooks/useShopify"
import { useCustomerContext } from "../../../hooks/useCustomer"

export const withBackInStockPopup = Component =>
  React.memo(({ name = "BackInStockPopup", selectedVariant, active, setActive }) => {
    const { backInStock, loading, errors: backInStockError } = useFunctions()
    const { decodeVariantId } = useShopify()
    const { customer } = useCustomerContext()
    const [data, setData] = useState({ email: "" })
    const [sent, setSent] = useState(false)
    const [errors, setErrors] = useState(false)

    const handleChange = useCallback(({ target: { name, value } }) => {
      setData(prevState => ({
        ...prevState,
        [name]: value,
      }))
    }, [])

    const handleSubmit = useCallback(async event => {
      event.preventDefault()
      try {
        const success = await backInStock(data.email, decodeVariantId(selectedVariant?.id))
        if (success) {
          setSent(true)
        } else {
          throw new Error(`[ERROR]`)
        }
      } catch (err) {
        setErrors(true)
      }
      //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
      if (customer && !data.email) {
        setData(prevState => ({
          ...prevState,
          email: customer.email,
        }))
      }
    }, [customer, data.email, setData])

    useEffect(() => {
      if (backInStockError && backInStockError?.length) {
        setErrors(!!backInStockError)
      }
    }, [backInStockError, setErrors])

    Component.displayName = name
    return useMemo(
      () => (
        <Component
          loading={loading}
          sent={sent}
          errors={errors}
          email={data.email}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          active={active}
          setActive={setActive}
        />
      ),
      [data.email, errors, sent, active, setActive, handleSubmit, handleChange, loading]
    )
  })
